import { FC, HTMLAttributes } from 'react';
import Lottie from 'lottie-react';
import styled from 'styled-components';

import TouchableOpacity from '@components/buttons/TouchableOpacity';
import { PremierText } from '@components/text';
import animationData from '@assets/animations/home.json';

const Container = styled(TouchableOpacity)`
  position: relative;
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Animation = styled(Lottie)`
  width: 72px;
  height: 72px;
`;

const Text = styled(PremierText)`
  position: absolute;
  max-width: 24px;
  font-size: ${({ theme }) => theme.fonts.fontSize.sm};
  text-wrap: wrap;
`;

type Props = {
  text: string;
} & HTMLAttributes<HTMLButtonElement>;

const LogoButton: FC<Props> = ({ text, ...props }) => {
  return (
    <Container {...props}>
      <Animation
        animationData={animationData}
        autoplay
        loop
        initialSegment={[65, 200]}
      />

      <Text>{text}</Text>
    </Container>
  );
};

export default LogoButton;
